export const TIPS = {
    NAME: {
        ROUTES: {
            HOME_VIEW: 'home_view',

            // Tributos
            INMUEBLES_VIEW: 'inmuebles_view',
            INMUEBLE_FORM: 'inmueble_form',
            COMERCIOS_VIEW: 'comercios_view',
            COMERCIO_FORM: 'comercio_form',
            VEHICULOS_VIEW: 'vehiculos_view',
            VEHICULO_FORM: 'vehiculo_form',
            CEMENTERIOS_VIEW: 'cementerios_view',
            CEMENTERIO_FORM: 'cementerio_form',
            FONDEADEROS_VIEW: 'fondeaderos_view',
            FONDEADERO_FORM: 'fondeadero_form',
            CUENTAS_ESPECIALES_VIEW: 'cuentas_especiales_view',
            CUENTA_ESPECIAL_FORM: 'cuenta_especial_form',
            CONTRIBUYENTES_VIEW: 'contribuyentes_view',
            CUENTA_CORRIENTE_VIEW: 'cuenta_corriente_view',
            DEUDA_FORM: 'deuda_form',
            PLAN_PAGO_VIEW: 'plan_pago_view',
            PAGO_CONTADO_FORM: 'pago_contado_form',
            PAGO_ACUENTA_FORM: 'pago_acuenta_form',

            // VEPs
            BUSQUEDA_VEPS_VIEW: 'busqueda_veps_view',
            DERECHOS_ESPECIALES_VIEW: 'derechos_especiales_view',
            DERECHO_ESPECIAL_FORM: 'derecho_especial_form',
            RECIBOS_ESPECIALES_VIEW: 'recibos_especiales_view',
            RECIBO_ESPECIAL_FORM: 'recibo_especial_form',
            PAGO_RECIBO_ESPECIAL_VIEW: 'pago_recibo_especial_view',
            PAGO_DERECHO_ESPECIAL_FORM: 'pago_derecho_especial_form',

            // Emisión
            PROCEDIMIENTOS_VIEW: 'procedimientos_view',
            PROCEDIMIENTO_FORM: 'procedimiento_form',
            EMISION_DEFINICIONES_VIEW: 'emision_definiciones_view',
            EMISION_DEFINICION_FORM: 'emision_definicion_form',
            EMISION_EJECUCIONES_VIEW: 'emision_ejecuciones_view',
            EMISION_EJECUCION_FORM: 'emision_ejecucion_form',
            CUENTAS_PRUEBA_VIEW: 'cuentas_prueba_view',

            // Financiación
            CONVENIO_DEFINICIONES_VIEW: 'convenio_definiciones_view',
            PLAN_PAGO_DEFINICIONES_VIEW: 'plan_pago_definiciones_view',
            PLAN_PAGO_DEFINICION_FORM: 'plan_pago_definicion_form',
            PAGOS_CONTADOS_DEFINICION_VIEW: 'pagos_contados_definicion_view',
            PAGO_CONTADO_DEFINICION_FORM: 'pago_contado_definicion_form',
            ESTADO_PLANES_PAGO_VIEW: 'estado_planes_pago_view',

            // Escribanos
            ESCRIBANOS_VIEW: 'escribanos_view',
            CERTIFICADOS_ESCRIBANO_VIEW: 'certificados_escribano_view',

            // Legales
            ORGANOS_JUDICIALES_VIEW: 'organos_judiciales_view',
            PLANTILLAS_DOCUMENTOS_VIEW: 'plantillas_documentos_view',
            TIPOS_ACTOS_PROCESALES_VIEW: 'tipos_actos_procesales_view',
            TIPO_RELACION_CERT_APREMIO_VIEW: 'tipo_relacion_cert_apremio_view',
            CERTIFICADOS_APREMIOS_VIEW: 'certificados_apremios_view',
            CERTIFICADO_APREMIO_FORM: 'certificado_apremio_form',
            CERTIFICADO_APREMIO_NUEVO_FORM: 'certificado_apremio_nuevo_form',
            APREMIOS_VIEW: 'apremios_view',
            APREMIO_FORM: 'apremio_form',

            // Entidades
            CATEGORIAS_TASAS_VIEW: 'categorias_tasas_view',
            TASAS_VIEW: 'tasas_view',
            TASA_FORM: 'tasa_form',
            TASA_FORM_NH: 'tasa_form_nh',
            SUBTASAS_VIEW: 'subtasas_view',
            SUBTASA_FORM: 'subtasa_form',
            SUBTASA_FORM_NH: 'subtasa_form_nh',
            TIPO_MOVIMIENTOS_VIEW: 'tipo_movimientos_view',
            CONTROLADORES_VIEW: 'controladores_view',
            TIPO_CONTROLADORES_VIEW: 'tipo_controladores_view',
            TIPO_CONDICIONES_ESPECIALES_VIEW: 'tipo_condiciones_especiales_view',
            TIPO_RECARGOS_DESCUENTOS_VIEW: 'tipo_recargos_descuentos_view',
            TIPOS_MULTAS_VIEW: 'tipos_multas_view',
            TIPOS_ARRENDAMIENTOS_VIEW: 'tipos_arrendamientos_view',
            INCISO_VEHICULOS_VIEW: 'inciso_vehiculos_view',
            CATEGORIAS_VEHICULOS_VIEW: 'categorias_vehiculos_view',
            RUBROS_VIEW: 'rubros_view',
            CATEGORIAS_UBICACIONES_VIEW: 'categorias_ubicaciones_view',
            ENTIDADES_LISTAS_VIEW: 'entidades_listas_view',
            ENTIDAD_FORM: 'entidad_form',
            TABLAS_DEFINICION_VIEW: 'tablas_definicion_view',
            TABLA_DEFINICION_FORM: 'tabla_definicion_form',

            // Configuración
            CONTROL_PROCESOS_VIEW: 'control_procesos_view',
            VARIABLES_VIEW: 'variables_view',
            VARIABLES_GLOBALES_VIEW: 'variables_globales_view',
            CLASES_ELEMENTOS_VIEW: 'clases_elementos_view',
            TIPOS_ELEMENTOS_VIEW: 'tipos_elementos_view',
            MODELOS_DECLARACIONES_JURADAS_VIEW: 'modelos_declaraciones_juradas_view',

            NOT_FOUND: 'not_found',
        },
        MODALS: {
            // Comunes
            ARCHIVO_MODAL: 'archivo_modal',
            OBSERVACION_MODAL: 'observacion_modal',
            ETIQUETA_MODAL: 'etiqueta_modal',
            ENTIDADES_MODAL: 'entidades_modal',
            LISTAS_MODAL: 'listas_modal',
            SELECCION_TASA_MODAL: 'seleccion_tasa_modal',
            SELECCION_SUB_TASA_MODAL: 'seleccion_sub_tasa_modal',
            SELECCION_CUENTA_MODAL: 'seleccion_cuenta_modal',
            SELECCION_PERSONA_MODAL: 'seleccion_persona_modal',
            PERSONAS_TIPO_MODAL: 'personas_tipo_modal',
            MULTA_MODAL: 'multa_modal',
            TIPO_MULTA_MODAL: 'tipo_multa_modal',

            // Tributos -> Comunes
            TIPO_INSTRUMENTO_MODAL: 'tipo_instrumento_modal',
            RECARGO_DESCUENTO_MODAL: 'recargo_descuento_modal',
            TIPO_RECARGO_DESCUENTO_MODAL: 'tipo_recargo_descuento_modal',
            INFORMACION_ADICIONAL_RECARGO_DESCUENTO_MODAL: 'informacion_adicional_recargo_descuento_modal',
            CONDICION_ESPECIAL_MODAL: 'condicion_especial_modal',
            INFORMACION_ADICIONAL_CONDICION_ESPECIAL_MODAL: 'informacion_adicional_condicion_especial_modal',
            DEBITOS_AUTOMATICOS_MODAL: 'debitos_automaticos_modal',
            INFORMACION_ADICIONAL_DEBITOS_AUTOMATICOS_MODAL: 'informacion_adicional_debitos_automaticos_modal',
            SELECCION_MEDIO_PAGO_MODAL: 'seleccion_medio_pago_modal',
            MEDIO_PAGO_MODAL: 'medio_pago_modal',
            DECLARACION_JURADA_MODAL: 'declaracion_jurada_modal',
            MODELO_DECLARACION_JURADA_MODAL: 'modelo_declaracion_jurada_modal',
            ORIGEN_DECLARACION_JURADA_MODAL: 'origen_declaracion_jurada_modal',
            INFORMACION_ADICIONAL_DECLARACIONES_JURADAS_MODAL: 'informacion_adicional_declaraciones_juradas_modal',
            NUMERO_DDJJ_MODAL: 'numero_ddjj_modal',
            CARTEL_MODAL: 'cartel_modal',
            INFORMACION_ADICIONAL_CARTEL_MODAL: 'informacion_adicional_cartel_modal',
            TIPO_ANUNCIO_MODAL: 'tipo_anuncio_modal',
            CATEGORIA_UBICACION_MODAL: 'categoria_ubicacion_modal',
            INFORMACION_ADICIONAL_MULTA_MODAL: 'informacion_adicional_multa_modal',
            VARIABLE_CUENTA_MODAL: 'variable_cuenta_modal',
            INFORMACION_ADICIONAL_RELACIONES_CUENTAS_MODAL: 'informacion_adicional_relaciones_cuentas_modal',
            INFORMACION_ADICIONAL_CONTROLADORES_CUENTAS_MODAL: 'informacion_adicional_controladores_cuentas_modal',
            RECIBO_ESPECIAL_MODAL: 'recibo_especial_modal',
            DIRECCIONES_RELACIONADAS_MODAL: 'direcciones_relacionadas_modal',
            CONDICIONES_ESPECIALES_CUENTA_CORRIENTE_MODAL: 'condiciones_especiales_cuenta_corriente_modal',

            // Tributos -> Menúes
            OBRAS_MODAL: 'obras_modal',
            EXPEDIENTES_MODAL: 'expedientes_modal',
            CERTIFICADOS_ESCRIBANOS_MODAL: 'certificados_escribanos_modal',
            RELACIONES_CUENTAS_MODAL: 'relaciones_cuentas_modal',
            CONTROLADORES_CUENTAS_MODAL: 'controladores_cuentas_modal',
            ZONAS_ENTREGA_MODAL: 'zonas_entrega_modal',
            VALUACIONES_MODAL: 'valuaciones_modal',
            EDESUR_MODAL: 'edesur_modal',
            CATASTRO_MODAL: 'catastro_modal',
            APLICACION_CREDITOS_MODAL: 'aplicacion_creditos_modal',
            CONDONACION_MODAL: 'condonacion_modal',
            PLANES_PAGO_MODAL: 'planes_pago_modal',
            LIQUIDACIONES_MODAL: 'liquidaciones_modal',
            INFORME_DEUDA_MODAL: 'informe_deuda_modal',
            DOMICILIO_MODAL: 'domicilio_modal',

            // Tributos -> Inmuebles
            VINCULO_INMUEBLE_MODAL: 'vinculo_inmueble_modal',
            INFORMACION_ADICIONAL_INMUEBLE_MODAL: 'informacion_adicional_inmueble_modal',
            LADO_TERRENO_MODAL: 'lado_terreno_modal',
            PAIS_MODAL: 'pais_modal',
            PROVINCIA_MODAL: 'provincia_modal',
            LOCALIDAD_MODAL: 'localidad_modal',
            SUPERFICIE_MODAL: 'superficie_modal',
            TIPO_SUPERFICIE_MODAL: 'tipo_superficie_modal',
            INFORMACION_ADICIONAL_SUPERFICIE_MODAL: 'informacion_adicional_superficie_modal',
            LADO_TERRENO_SERVICIO_MODAL: 'lado_terreno_servicio_modal',
            LADO_TERRENO_OBRA_MODAL: 'lado_terreno_obra_modal',
            OBRA_MODAL: 'obra_modal',
            INFORMACION_ADICIONAL_LADO_TERRENO_MODAL: 'informacion_adicional_lado_terreno_modal',
            OBRA_INMUEBLE_MODAL: 'obra_inmueble_modal',
            INFORMACION_ADICIONAL_OBRA_INMUEBLE_MODAL: 'informacion_adicional_obra_inmueble_modal',
            OBRA_INMUEBLE_DETALLE_MODAL: 'obra_inmueble_detalle_modal',
            INFORMACION_ADICIONAL_OBRA_INMUEBLE_DETALLE_MODAL: 'informacion_adicional_obra_inmueble_detalle_modal',
            TIPO_MOVIMIENTO_MODAL: 'tipo_movimiento_modal',
            SELECCION_TIPO_TRIBUTO_MODAL: 'seleccion_tipo_tributo_modal',
            CONTROLADOR_CUENTA_MODAL: 'controlador_cuenta_modal',
            TIPO_CONTROLADOR_MODAL: 'tipo_controlador_modal',
            CONTROLADOR_MODAL: 'controlador_modal',
            INFORMACION_ADICIONAL_CONTROLADOR_CUENTA_MODAL: 'informacion_adicional_controlador_cuenta_modal',
            ZONA_ENTREGA_MODAL: 'zona_entrega_modal',
            INFORMACION_ADICIONAL_ZONA_ENTREGA_MODAL: 'informacion_adicional_zona_entrega_modal',
            VALUACION_MODAL: 'valuacion_modal',
            INFORMACION_ADICIONAL_VALUACION_MODAL: 'informacion_adicional_valuacion_modal',
            EDESUR_CLIENTE_MODAL: 'edesur_cliente_modal',
            INFORMACION_ADICIONAL_CLIENTE_EDESUR_MODAL: 'informacion_adicional_cliente_edesur_modal',
            CUENTA_DEBITOS_CREDITOS_MODAL: 'cuenta_debitos_creditos_modal',

            // Tributos -> Comercios
            INFORMACION_ADICIONAL_COMERCIO_MODAL: 'informacion_adicional_comercio_modal',
            INFORMACION_ADICIONAL_VINCULO_COMERCIO_MODAL: 'informacion_adicional_vinculo_comercio_modal',
            VINCULO_COMERCIO_MODAL: 'vinculo_comercio_modal',
            TIPO_UBICACION_MODAL: 'tipo_ubicacion_modal',
            RUBRO_COMERCIO_MODAL: 'rubro_comercio_modal',
            TIPO_RUBRO_COMERCIO_MODAL: 'tipo_rubro_comercio_modal',
            TIPO_UBICACION_COMERCIO_MODAL: 'tipo_ubicacion_comercio_modal',
            TIPO_RUBRO_LIQUIDACION_MODAL: 'tipo_rubro_liquidacion_modal',
            TIPO_RUBRO_PROVINCIA_MODAL: 'tipo_rubro_provincia_modal',
            TIPO_RUBRO_BCRA_MODAL: 'tipo_rubro_bcra_modal',
            TIPO_MOTIVO_BAJA_RUBRO_COMERCIO_MODAL: 'tipo_motivo_baja_rubro_comercio_modal',
            INFORMACION_ADICIONAL_RUBRO_COMERCIO_MODAL: 'informacion_adicional_rubro_comercio_modal',
            MOTIVO_BAJA_COMERCIO_MODAL: 'motivo_baja_comercio_modal',
            INSPECCION_MODAL: 'inspeccion_modal',
            SUPERVISOR_MODAL: 'supervisor_modal',
            INSPECTOR_MODAL: 'inspector_modal',
            RETENCION_MODAL: 'retencion_modal',
            INFORMACION_ADICIONAL_INSPECCION_MODAL: 'informacion_adicional_inspeccion_modal',

            // Tributos -> Vehículos
            INFORMACION_ADICIONAL_VEHICULO_MODAL: 'informacion_adicional_vehiculo_modal',
            VINCULO_VEHICULO_MODAL: 'vinculo_vehiculo_modal',
            INFORMACION_ADICIONAL_VINCULO_VEHICULO_MODAL: 'informacion_adicional_vinculo_vehiculo_modal',
            INCISO_VEHICULO_MODAL: 'inciso_vehiculo_modal',
            INCISO_VEHICULO_EMISION_DEFINICION_MODAL: 'inciso_vehiculo_emision_definicion_modal',
            TIPO_VEHICULO_MODAL: 'tipo_vehiculo_modal',
            CATEGORIA_VEHICULO_MODAL: 'categoria_vehiculo_modal',

            // Tributos -> Cementerios
            INFORMACION_ADICIONAL_CEMENTERIO_MODAL: 'informacion_adicional_cementerio_modal',
            INFORMACION_ADICIONAL_VINCULO_CEMENTERIO_MODAL: 'informacion_adicional_vinculo_cementerio_modal',
            VINCULO_CEMENTERIO_MODAL: 'vinculo_cementerio_modal',
            TIPO_CONSTRUCCION_FUNERARIA_MODAL: 'tipo_construccion_funeraria_modal',
            INHUMADO_MODAL: 'inhumado_modal',
            NACIONALIDAD_MODAL: 'nacionalidad_modal',
            INFORMACION_ADICIONAL_INHUMADO_MODAL: 'informacion_adicional_inhumado_modal',

            // Tributos -> Especiales
            INFORMACION_ADICIONAL_CUENTA_ESPECIAL_MODAL: 'informacion_adicional_cuenta_especial_modal',
            VINCULO_ESPECIAL_MODAL: 'vinculo_especial_modal',

            // Tributos -> Fondeaderos
            INFORMACION_ADICIONAL_FONDEADERO_MODAL: 'informacion_adicional_fondeadero_modal',
            VINCULO_FONDEADERO_MODAL: 'vinculo_fondeadero_modal',

            // Tributos -> Contribuyentes
            INFORMACION_ADICIONAL_TRIBUTO_MODAL: 'informacion_adicional_tributo_modal',

            // Facturación
            DEFINICION_CONCEPTO_MODAL: 'definicion_concepto_modal',

            // Emisión -> Procedimientos
            INFORMACION_ADICIONAL_PROCEDIMIENTO_MODAL: 'informacion_adicional_procedimiento_modal',
            FILTROS_DISPONIBLES_MODAL: 'filtros_disponibles_modal',
            PARAMETRO_MODAL: 'parametro_modal',
            COLECCION_MODAL: 'coleccion_modal',
            NUMERACION_MODAL: 'numeracion_modal',
            DEFINICION_BOLETA_MODAL: 'definicion_boleta_modal',
            PROCEDIMIENTO_MODAL: 'procedimiento_modal',

            // Emisión -> Definiciones
            EMISION_EJECUCION_CUOTA_MODAL: 'emision_ejecucion_cuota_modal',
            EMISION_CUOTA_MODAL: 'emision_cuota_modal',
            EMISION_CALCULO_MODAL: 'emision_calculo_modal',
            EMISION_CONCEPTO_MODAL: 'emision_concepto_modal',
            EMISION_CUENTA_CORRIENTE_MODAL: 'emision_cuenta_corriente_modal',
            EMISION_IMPUTACION_CONTABLE_MODAL: 'emision_imputacion_contable_modal',
            INFORMACION_ADICIONAL_DEFINICION_EMISIONES_MODAL: 'informacion_adicional_definicion_emisiones_modal',
            EMISION_BOLETA_SECCION_MODAL: 'emision_boleta_seccion_modal',
            EMISION_BOLETA_DEFINICION_SECCION_MODAL: 'emision_boleta_definicion_seccion_modal',

            // Emisión -> Ejecuciones
            INFORMACION_ADICIONAL_EMISION_EJECUCIONES_MODAL: 'informacion_adicional_emision_ejecuciones_modal',
            DEFINICION_EMISIONES_MODAL: 'definicion_emisiones_modal',
            INFORMACION_ADICIONAL_PROCESO_MODAL: 'informacion_adicional_proceso_modal',
            PROCESO_MODAL: 'proceso_modal',

            // Emisión -> Cuentas de Prueba
            CUENTA_PRUEBA_DEFINICION_MODAL: 'cuenta_prueba_definicion_modal',

            // Financiación -> Convenios
            CONVENIO_DEFINICIONES_MODAL: 'convenio_definiciones_modal',

            // Financiación -> Plan de Pagos y Pago Contado
            TIPO_PLAN_PAGO_MODAL: 'tipo_plan_pago_modal',
            INFORMACION_ADICIONAL_PLAN_PAGO_MODAL: 'informacion_adicional_plan_pago_modal',
            RELACIONES_PERMITIDAS_MODAL: 'relaciones_permitidas_modal',
            TIPO_VENCIMIENTO_PLAN_PAGO_MODAL: 'tipo_vencimiento_plan_pago_modal',
            TIPO_CONDICION_ESPECIAL_MODAL: 'tipo_condicion_especial_modal',
            QUITA_DEFINICION_MODAL: 'quita_definicion_modal',
            INTERES_DEFINICION_MODAL: 'interes_definicion_modal',
            ANTICIPO_DEFINICION_MODAL: 'anticipo_definicion_modal',
            CADUCIDAD_DEFINICION_MODAL: 'caducidad_definicion_modal',
            TASAS_MODAL: 'tasas_modal',
            CONDICION_FISCAL_MODAL: 'condicion_fiscal_modal',
            FORMA_JURIDICA_MODAL: 'forma_juridica_modal',
            RUBROS_COMERCIO_MODAL: 'rubros_comercio_modal',
            ZONAS_TARIFARIAS_MODAL: 'zonas_tarifarias_modal',
            GRUPO_MODAL: 'grupo_modal',
            RUBROS_AFIP_MODAL: 'rubros_afip_modal',
            INFORMACION_ADICIONAL_PAGO_CONTADO_MODAL: 'informacion_adicional_pago_contado_modal',

            // Escribanos -> Escribanos
            ESCRIBANO_MODAL: 'escribano_modal',

            // Escribanos -> Certificados
            CERTIFICADO_ESCRIBANO_MODAL: 'certificado_escribano_modal',
            INFORMACION_ADICIONAL_CERTIFICADO_ESCRIBANO_MODAL: 'informacion_adicional_certificado_escribano_modal',
            OBJETO_CERTIFICADO_MODAL: 'objeto_certificado_modal',

            // Legales -> Plantilla Documento
            PLANTILLA_DOCUMENTO_MODAL: 'plantilla_documento_modal',

            // Legales -> Apremios
            SELECCION_EXPEDIENTE_MODAL: 'seleccion_expediente_modal',
            EXPEDIENTE_MODAL: 'expediente_modal',
            ORGANISMO_JUDICIAL_MODAL: 'organismo_judicial_modal',
            INFORMACION_ADICIONAL_APREMIO_MODAL: 'informacion_adicional_apremio_modal',
            JUICIO_CITACION_MODAL: 'juicio_citacion_modal',
            INFORMACION_ADICIONAL_JUICIO_CITACION_MODAL: 'informacion_adicional_juicio_citacion_modal',
            ACTO_PROCESAL_MODAL: 'acto_procesal_modal',
            SELECCION_TIPO_ACTO_PROCESAL_MODAL: 'seleccion_tipo_acto_procesal_modal',
            INFORMACION_ADICIONAL_ACTO_PROCESAL_MODAL: 'informacion_adicional_acto_procesal_modal',

            // Entidades -> Tasas
            CATEGORIA_TASA_MODAL: 'categoria_tasa_modal',
            INFORMACION_ADICIONAL_TASA_MODAL: 'informacion_adicional_tasa_modal',

            // Entidades -> Subtasas
            INFORMACION_ADICIONAL_SUB_TASA_MODAL: 'informacion_adicional_sub_tasa_modal',
            INFORMACION_ADICIONAL_IMPUTACIONES_MODAL: 'informacion_adicional_imputaciones_modal',
            IMPUTACION_SUB_TASA_MODAL: 'imputacion_sub_tasa_modal',
            VALOR_SUB_TASA_MODAL: 'valor_sub_tasa_modal',

            // Entidades -> Rubros
            RUBRO_MODAL: 'rubro_modal',

            // Entidades -> Listas
            ENTIDAD_MODAL: 'entidad_modal',

            // Entidades -> Tablas
            COLUMNAS_MODAL: 'columnas_modal',
            VALORES_MODAL: 'valores_modal',

            // Configuración -> Definición de Variables
            VARIABLE_MODAL: 'variable_modal',

            // Configuración -> Variables Globales
            SELECCION_TIPO_VARIABLE_MODAL: 'seleccion_tipo_variable_modal',
            VARIABLE_GLOBAL_MODAL: 'variable_global_modal',

            // Configuración -> Clases de Elementos
            CLASE_ELEMENTO_MODAL: 'clase_elemento_modal',

            // Configuración -> Tipos de Elementos
            TIPO_ELEMENTO_MODAL: 'tipo_elemento_modal',
            VALOR_MODAL: 'valor_modal',

            // Configuración -> Modelos de Declaraciones Juradas
            MODELO_DECLARACION_JURADA_EMISION_DEFINICION_MODAL: 'modelo_declaracion_jurada_emision_definicion_modal',
            EMISION_DEFINICION_MODAL: 'emision_definicion_modal',

            // Configuración -> Importar
            IMPORTADOR_MODAL: 'importador_modal',

            // Configuración -> Exportar
            EXPORTADOR_MODAL: 'exportador_modal',
        }
    },
};
